import _ from "lodash"
import { Navigate, useParams } from "react-router-dom"
import { z } from "zod"

import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { CatalogProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/catalog/CatalogProductsTable"
import { CustomFieldsProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/custom-fields/CustomFieldsProductsTable"
import { StandardsProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/standards/StandardsProductsTable"
import { TraceabilityProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/traceability/TraceabilityProductsTable"
import { ProductsListView } from "~/pages/Brand/Products/List/constants.ts"

export const ProductTableFactory = () => {
  const params = useParams()

  const view = z
    .enum(ProductsListView)
    .safeParse(_.camelCase(params.view) || ProductsListView.GENERAL)

  const resolver = {
    [ProductsListView.GENERAL]: (
      <HeaderControlsProvider
        initialColumnPinning={{ left: ["name", "reference"] }}
      >
        <CatalogProductsTable />
      </HeaderControlsProvider>
    ),
    [ProductsListView.CUSTOM_FIELDS]: (
      <HeaderControlsProvider>
        <CustomFieldsProductsTable />
      </HeaderControlsProvider>
    ),
    [ProductsListView.CERTIFICATES]: (
      <HeaderControlsProvider>
        <StandardsProductsTable />
      </HeaderControlsProvider>
    ),
    [ProductsListView.TRACEABILITY]: (
      <HeaderControlsProvider>
        <TraceabilityProductsTable />
      </HeaderControlsProvider>
    ),
  }

  if (!view.success) {
    return <Navigate to="/products" />
  }

  const TableComponent = resolver[view.data]

  return <>{TableComponent}</>
}
